export default function Tag({ children }) {
  return (
    <span className="rounded-full bg-mint px-[13px] py-1.5 text-[13px] font-bold text-forest">
      {children}
    </span>
  );
}
